const enabled = (value, fallback = true) => {
  if (value === undefined || value === null) return fallback;
  return value === true || value === 1 || value === "1" || value === "true";
};

export const resolveHomeStreamingsConfig = (home = {}) => ({
  status: enabled(home?.streamings?.status, enabled(home?.enableStreamingRow, true)),
  title: home?.streamings?.title || "Transmissões",
  limit: 6,
  sort: home?.streamings?.sort === "nearest_start" ? "nearest_start" : "live_first",
});

export const normalizeHomeRowLimits = (eventJson = {}) => {
  const home = eventJson?.home;
  if (!home || typeof home !== "object" || Array.isArray(home)) return eventJson;
  return {
    ...eventJson,
    home: {
      ...home,
      activities: {
        ...(home.activities || {}),
        limit: 6,
        sort: "recent",
      },
      streamings: { ...(home.streamings || {}), limit: 6 },
    },
  };
};

export const normalizeLegacyHomeStreamings = (eventJson = {}) => {
  const home = eventJson?.home;
  if (!home || typeof home !== "object" || Array.isArray(home)) return eventJson;
  if (home?.streamings?.status !== undefined) return eventJson;

  return {
    ...eventJson,
    home: {
      ...home,
      streamings: {
        ...(home.streamings || {}),
        status: enabled(home.enableStreamingRow, true),
      },
    },
  };
};
